import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWweComponent } from './simple-icons-wwe.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWweComponent ],
    exports:      [ SimpleIconsWweComponent ],
    bootstrap:    []
})
export class SimpleIconsWweModule {}
